import React, { Component } from 'react';
import Select from 'react-select';



class DataOverwrite extends Component{

    constructor(props){
        super(props);

        this.state={
            actionFlag:{
                "file_name":true,
                "gran":true,
            },
            actions:[
                {"label":"Overwrite entire table","value":"full"},
                {"label":"Overwrite data for file","value":"file"},
                {"label":"Overwrite data for a period","value":"period"},
            ],
            period:[
                { "label": "MTD", "value": "month" },
                { "label": "YTD", "value": "year" },
            ],
            // month:[
            //     { "label": "January", "value": "January" },
            //     { "label": "February", "value": "February" },
            //     { "label": "March", "value": "March" },
            //     { "label": "April", "value": "April" },
            //     { "label": "May", "value": "May" },
            //     { "label": "June", "value": "June" },
            //     { "label": "July", "value": "July" },
            //     { "label": "August", "value": "August" },
            //     { "label": "September", "value": "September" },
            //     { "label": "October", "value": "October" },
            //     { "label": "November", "value": "November" },
            //     { "label": "December", "value": "December" },
            // ],
            month: ["January","February","March","April","May","June","July","August","September","October","November","December"],
            data: null,
            condition:null,
            overwriteAction:null,
            checkSubmit:false
        }


        this.setOverwriteParams = this.setOverwriteParams.bind(this);
        this.handleActionChange = this.handleActionChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.calculateTimeRangeArray = this.calculateTimeRangeArray.bind(this);
    }


    componentWillMount(){

        if(this.state.data  == null){
            const currentData = this.setOverwriteParams();
            this.setState({
                data:currentData
            })
        }     
    }

    componentDidUpdate(){
        let currentState = this.state.data.tableName;
        if (currentState !== this.props.data.tableName) {
           let currentData = this.setOverwriteParams();
            this.setState({
                data: currentData,
                condition: null
            })
        }
    }

    setOverwriteParams(){

        const tableData = this.props.data;
        let data = {};
        data.tableName = tableData.tableName;

        if (tableData.file_names !== null){
            data.fileList = tableData.file_names.split(',').map((element, i) => {
                let inner = {};
                inner.label = element;
                inner.value = `${element};file_name`;
                return inner;
            })
        }
        else{
            data.fileList = [];
        }
     

        if (tableData.date_information !== null){
            data.dateColumn = Object.keys(JSON.parse(tableData.date_information)).map((element, i) => {
                let inner = {};
                inner.label = element;
                inner.value = element;
                return inner;
            });
        }
        else{
            data.dateColumn = [];
        }
        
        if (tableData.date_information !== null) {
            data.dateRange = JSON.parse(tableData.date_information);
        }
        else {
            data.dateRange = [];
        }      
        return data;

    }

    handleActionChange(value,reference){
        var condition = this.state.condition;
        var checkSubmit = false;
        if(reference.name == "actionDropdown"){
            let actionFlag = this.state.actionFlag;
            if(value.value == "file"){
                actionFlag.file_name = false;
                actionFlag.gran = true;
            }

            if (value.value == "period") {
                actionFlag.file_name = true;
                actionFlag.gran = false;
            }

            if (value.value == "full") {
                actionFlag.file_name = true;
                actionFlag.gran = true;  
                if (condition == null) {
                    condition = {};
                }
                if (condition[value.value] == null && condition[value.value] == undefined) {
                    condition[value.value] = {};
                }

                condition[value.value][value.value] = true;
                checkSubmit = true;
      
            }

            this.setState({
                actionFlag: actionFlag,
                overwriteAction: value.value,
                condition:condition,
                checkSubmit: checkSubmit
            });

        }
    }

    handleInputChange(value,reference){
        var condition = this.state.condition;
        var checkSubmit = false;

        if(condition == null){
            condition = {};
        }
        if (condition[this.state.overwriteAction] == null && condition[this.state.overwriteAction] == undefined){
            condition[this.state.overwriteAction] = {};
        }
        
        if (this.state.overwriteAction == "file") {
            condition[this.state.overwriteAction]["filter"] = {};
            condition[this.state.overwriteAction]["filter"]["value"] = value.value;
            checkSubmit = true;
        }

        if (this.state.overwriteAction == "period") {

            if(condition[this.state.overwriteAction]["filter"] == null || condition[this.state.overwriteAction]["filter"] == undefined){
                condition[this.state.overwriteAction]["filter"] = {};
            }

            if (reference.name == "gran") {
                if (condition[this.state.overwriteAction]["filter"]["period"] == null || condition[this.state.overwriteAction]["filter"]["period"] == undefined ){
                    condition[this.state.overwriteAction]["filter"]["period"] = {};
                }
                condition[this.state.overwriteAction]["filter"]["period"]["gran"] = value.value;
            }

            if (reference.name == "timeValue") {
                condition[this.state.overwriteAction]["filter"]["period"]["value"] = value.value;
                checkSubmit = true;
            }

         
            if (reference.name =="dateValue"){
                condition[this.state.overwriteAction]["filter"]["date_column"] = value.value;
            }
            
        }

        this.setState({
            condition:condition,
            checkSubmit:checkSubmit
        })
        
    }

    calculateTimeRangeArray(dateParams){
        let timeDropdown = [];
        let period = dateParams.period
        let min_date = dateParams.min_date;
        let max_date = dateParams.max_date;
        let start_time = null;
        let end_time = null;
        var monthArray = this.state.month;
        // ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],

        if(period == "year"){
            start_time = Number(moment(min_date, 'YYYY/MM/DD').format('YYYY'));
            end_time = Number(moment(max_date, 'YYYY/MM/DD').format('YYYY'));
            for (let index = start_time; index <= end_time; index++) {
                let inner = {};
                inner.label = index;
                inner.value = index;
                timeDropdown.push(inner);
            }
        }

        if(period == "month"){
            let yearDifference = Number(moment(max_date, 'YYYY/MM/DD').format('YYYY')) - Number(moment(min_date, 'YYYY/MM/DD').format('YYYY'));
            let start_month = Number(moment(min_date, 'YYYY/MM/DD').format('M'));
            let end_month = Number(moment(max_date, 'YYYY/MM/DD').format('M'));


            if(yearDifference == 0){
                monthArray = [...monthArray.slice(start_month-1, end_month)];
            }
            else if(yearDifference == 1){
                    
                monthArray = [...monthArray.slice(0, end_month),...monthArray.slice(start_month-1,12)];
                monthArray = [...new Set(monthArray)];
               
            }

            timeDropdown = monthArray.map((element,i)=>{
                let inner = {};
                inner.label = element;
                inner.value = element;
                return inner;
            })
        }
        return timeDropdown;

    }


    render(){

        var timeDropdown = [];
        var periodSelectCheck = null;
        var dateSelectCheck = null;
        if(this.state.overwriteAction == "period"){
            if (this.state.condition !== null){
                if (this.state.condition["period"]["filter"]["period"] !== null && this.state.condition["period"]["filter"]["period"] !== undefined){
                    let granularity = this.state.condition["period"]["filter"]["period"]["gran"];
                    if (granularity !== null && granularity !== undefined) {
                        let date_column = this.state.condition["period"]["filter"]["date_column"]
                        if (date_column !== null && date_column !== undefined) {
                            let dateRange = this.state.data.dateRange[date_column];

                            let dateParams = {
                                "min_date": dateRange.startDate,
                                "max_date": dateRange.endDate,
                                "period": granularity
                            };

                            if (granularity == "month") {
                                timeDropdown = this.calculateTimeRangeArray(dateParams);
                            }

                            if (granularity == "year") {
                                timeDropdown = this.calculateTimeRangeArray(dateParams);

                            }
                        }
                        periodSelectCheck = this.state.condition[this.state.overwriteAction]["filter"]["period"]["gran"];
                        dateSelectCheck = this.state.condition[this.state.overwriteAction]["filter"]["date_column"];
                    }                    
                }
                
            }
        }


        return(
            <>
                <form encType="multipart/form-data" autoComplete="off" name="overwrite_form_name">
                        <div className="custom-file">
                        <input type="file" accept=".csv" className="custom-file-input" id="operateFile" />
                            <label className="custom-file-label" htmlFor="customFile">Choose File</label>
                        </div>
                    <div className="form-group mg-y-5">
                        <label htmlFor="overwriteAction">Select Overwrite Action</label>
                        <Select
                            id="overwriteAction"
                            // defaultValue={{"label":"Select action", "value":"default"}}
                            placeholder="Select Overwrite Action"
                            name="actionDropdown"
                            options={this.state.actions}
                            onChange={this.handleActionChange}
                            />
                    </div> 
                    <div className="form-group mg-y-5" hidden={this.state.actionFlag.file_name}>
                        <label htmlFor="fileSelect">Select File</label>
                        <Select
                            id="fileSelect"
                            // defaultValue={{ "label": "Select file", "value": "default" }}
                            placeholder="Select File"
                            name="file_name"
                            options={(this.state.data !== null) ? this.state.data.fileList : []}
                            onChange={this.handleInputChange}
                        />
                    </div> 
                    <div className="form-group mg-y-5" hidden={this.state.actionFlag.gran}>
                        <label htmlFor="periodSelect">Select Period</label>
                        <Select
                            id="periodSelect"
                            // defaultValue={this.state.period[0]}
                            placeholder="Select Period"
                            name="gran"
                            options={this.state.period}
                            onChange={this.handleInputChange}
                        />
                    </div> 
                    <div className="form-group mg-y-5" hidden={(periodSelectCheck == null || periodSelectCheck == undefined)?true:false }>
                        <label htmlFor="dateColSelect">Select Date Column</label>
                        <Select
                            id="dateColSelect"
                            // defaultValue={this.state.period[0]}
                            placeholder="Select Date Column"
                            name="dateValue"
                            options={(this.state.data !== null) ? this.state.data.dateColumn : []}
                            onChange={this.handleInputChange}
                        />
                    </div> 
                    <div className="form-group mg-y-5" hidden={(dateSelectCheck == null || dateSelectCheck == undefined) ? true : false}>
                        <label htmlFor="timeSelect">Select Month/Year</label>
                        <Select
                            id="timeSelect"
                            // defaultValue={[]}
                            placeholder="Select Month/Year"
                            name="timeValue"
                            options={timeDropdown}
                            onChange={this.handleInputChange}
                        />
                    </div> 
                </form>
            </>
        )
    }
}

export default DataOverwrite;